"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
function debounce(functionToDebounce, timeout) {
    if (timeout === void 0) { timeout = 5; }
    var timer;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(timer);
        timer = setTimeout(function () { return functionToDebounce.apply(_this, args); }, timeout);
    };
}
exports.debounce = debounce;
//# sourceMappingURL=debounce.js.map